import * as Types from '@frameio/graphql-client/generated/types';

import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
import gql from 'graphql-tag';

import { useQuery, useLazyQuery, useMutation, useFragment, useSubscription } from '@apollo/client';
import type { QueryHookOptions, LazyQueryHookOptions, MutationHookOptions, SubscriptionHookOptions, UseFragmentOptions } from '@apollo/client';

export type FolderRestrictionsFragment = { __typename?: 'FolderAsset', id: string, isRestrictedDescendant?: boolean | null, restricted?: boolean | null };

export const FolderRestrictions = /*#__PURE__*/ gql`
    fragment FolderRestrictions on FolderAsset {
  id
  isRestrictedDescendant
  restricted
}
    ` as unknown as DocumentNode<FolderRestrictionsFragment, unknown>;

        

        
export const useFolderRestrictionsFragment = (
  input: string | Omit<UseFragmentOptions<FolderRestrictionsFragment, any>, 'fragment' | 'fragmentName'> | undefined | null
) => {
  const options = (() => {
    if (!input) return { from: null };
    if (typeof input === 'string') return { from: { id: input, __typename: 'FolderAsset' } };
    return input;
  })();

  return useFragment<FolderRestrictionsFragment>({
    fragment: FolderRestrictions,
    fragmentName: 'FolderRestrictions',
    ...options,
  });
};
  
        